export const REPLAY_SHARE_TOAST_MS = 1600

export function buildReplayShareUrl(replayId) {
  const u = new URL(window.location.href)
  u.searchParams.set('replay', String(replayId).trim())
  return u.toString()
}

export function stripReplayQueryParam() {
  const u = new URL(window.location.href)
  if (!u.searchParams.has('replay')) return
  u.searchParams.delete('replay')
  const qs = u.searchParams.toString()
  history.replaceState(null, '', `${u.pathname}${qs ? `?${qs}` : ''}${u.hash}`)
}
